import { Permission } from '@amzn/coral_com-amazon-passportaccessmanagementcore';

export const AUTHORIZATION = {
  ADMIN: Permission.ADMIN,
  ACCESS: Permission.ACCESS,
};
